import './App.css';
import {createTheme, ThemeProvider} from '@material-ui/core/styles';
import TMSearch from "./components/TMSearch";
import React from "react";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

const domain = window.location.host;
let iplf = false
let knk = false
if(domain.includes('ipandlegalfilings')){
    iplf=true
}
if(domain.includes('khuranaandkhurana')){
    knk=true
}

const theme = createTheme({
    palette: {
        primary: {
            main: iplf?'#5E6EE7':'#AB5212',
        },
        secondary: {
            main: iplf?'#5E6EE7':'#AB5212',
        },
    },

    overrides: {
        // Style sheet name ⚛️
        MuiButton: {
            root: {
                borderRadius: 0,
            },
            contained: {
                boxShadow: "none"
            }
        },
        MuiOutlinedInput: {
            root: {
                borderRadius: 0,
            },
        }
    },
});

function App() {
    return (
        <ThemeProvider theme={theme}>
            {knk && <Navbar/>}
            <div className="p-2 py-6 max-w-4xl mx-auto flex flex-col min-h-screen">
                <TMSearch/>
            </div>
            {knk && <Footer/>}
        </ThemeProvider>
    );
}

export default App;
